import http from './http'

export function getSettings() {
  return http.get('api/settings')
}

// Public subset (no auth) — currency and branding for the public site.
export function getPublicSettings() {
  return http.get('api/public/settings')
}

export function updateSettings(payload) {
  return http.put('api/settings', payload)
}

// Public contact form submission (no auth).
export function submitContactMessage(payload) {
  return http.post('api/public/contact', payload)
}
